var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var uiMask = require('angular-ui-mask')
var guid = require('aem-libs/src/guid')

angular.module('OwInputTelCmp', [uiMask])
  .component('owInputTel', {
    template: require('./ow-input-tel.component.tpl.html'),
    controller: OwInputTelCtrl,
    controllerAs: 'vm',
    bindings: {
      formFieldId: '<',
      value: '<',
      errorMessages: '<',
      label: '<',
      onChanged: '&',
      tooltipLabel: '<',
      tooltipClass: '<',
      inputClass: '@',
      validation: '<',
      ngRequired: '<',
      ngDisabled: '<',
      themeClass: '<'
    }
  })

OwInputTelCtrl.$inject = ['i18n', '$timeout']

function OwInputTelCtrl (i18n, $timeout) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.id = vm.formFieldId + '-' + guid()
    vm.uiOptions = {
      clearOnBlur: false,
      maskDefinitions: {
        '9': /\d/,
        '+': /\+/,
        'A': /[a-zA-Z]/,
        '*': /[a-zA-Z0-9]/
      }
    }
    vm.pattern = null
    try {
      if (vm.validation.validationType === 'tel.Bez1/8') {
        vm.pattern = /^\+420[ ][2-7,9,0]\d{2}[ ]\d{3}[ ]\d{3}$/gi
      }
    } catch (e) {}
    vm.changed = changed
    vm.setCaretPositionAfterIntPrefix = setCaretPositionAfterIntPrefix
    $timeout(processErrors)
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.errorMessages) {
      $timeout(processErrors)
    }
  }

  function processErrors () {
    if (angular.isArray(vm.errorMessages)) {
      // reset current errors
      Object.keys(vm.form.field.$error).forEach(function (error) {
        vm.form.field.$setValidity(error, true)
      })
      // set external errors
      vm.errorMessages.forEach(function (error) {
        var formattedError = error.replace('.', '') // replaceses inappropriate characters
        vm.form.field.$setValidity(formattedError, false)
      })
    }
  }

  function changed () {
    vm.onChanged({ value: vm.value, formFieldId: vm.formFieldId })
  }

  function setCaretPositionAfterIntPrefix () {
    // ui-mask fix
    var input = document.getElementById(vm.id)
    var pos = 5
    if (input.setSelectionRange) {
      input.setSelectionRange(pos, pos)
      $timeout(function () {
        input.setSelectionRange(pos, pos)
      })
    }
  }
}
